import { Environments } from '../@types/configuration';

export interface EnvironmentVariables {
  ADMIN_API_URL: string;
  API_URL: string;
  ENV: Environments;
  MS_ENTRA_CLIENT_ID: string;
  MS_ENTRA_AUTHORITY : string;
  MS_ENTRA_SECRET : string;
  MS_ENTRA_SCOPES : string[];
}

const environment: EnvironmentVariables = Object.seal({
  ADMIN_API_URL: process.env.REACT_APP_ADMIN_API_URL!,
  API_URL: process.env.REACT_APP_API_URL!,
  ENV: process.env.REACT_APP_ENV as Environments,
  MS_ENTRA_CLIENT_ID: process.env.REACT_APP_MS_ENTRA_CLIENT_ID!,
  MS_ENTRA_AUTHORITY : process.env.REACT_APP_MS_ENTRA_AUTHORITY!,
  MS_ENTRA_SECRET : process.env.REACT_APP_MS_ENTRA_SECRET!,
  MS_ENTRA_SCOPES : process.env.REACT_APP_MS_ENTRA_SCOPES!.split(',')
});

export const appTitle = 'Meal Plate Analyser';

export default environment;
